import {
  usePropsFor,
  VideoGallery,
  ControlBar,
  CameraButton,
  EndCallButton,
  ControlBarButton,
  MicrophoneButton,
} from "@azure/communication-react";
import { Stack, MessageBar, MessageBarType } from "@fluentui/react";
import React, { useCallback, useState } from "react";
import {
} from "@fluentui/react-icons";
import { useId, useBoolean } from "@fluentui/react-hooks";
import { Dialog, DialogType } from "@fluentui/react/lib/Dialog";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { ContextualMenu } from "@fluentui/react/lib/ContextualMenu";
import { useHistory } from "react-router-dom";
import { useGlobalState } from "../utils/GlobalState";

export interface CallScreenProps {
  onCallEnded: () => void;
}

const dialogStyles = { main: { maxWidth: 450 } };
const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
  keepInBounds: true,
};

const dialogContentProps = {
  type: DialogType.normal,
  subText: "The exam is complete and the recording has been uploaded. Please advise your supervisor.",
};


function CallingComponents(props: CallScreenProps): JSX.Element {
  const history = useHistory();
  const videoGalleryProps = usePropsFor(VideoGallery);
  const cameraProps = usePropsFor(CameraButton);
  const microphoneProps = usePropsFor(MicrophoneButton);
  const endCallProps = usePropsFor(EndCallButton);
  const [callEnded, setCallEnded] = useState(false);
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const [isDraggable, { toggle: toggleIsDraggable }] = useBoolean(false);
  const labelId: string = useId("dialogLabel");
  const subTextId: string = useId("subTextLabel");  
  const modalProps = React.useMemo(
    () => ({
      titleAriaId: labelId,
      subtitleAriaId: subTextId,
      isBlocking: false,
      styles: dialogStyles,
      dragOptions: isDraggable ? dragOptions : undefined,
    }),
    [isDraggable, labelId, subTextId]
  );
  
  const { state } = useGlobalState();

  const mouseClickEvents = ['click'];
  const simulateMouseClick = (element:any) => {
    mouseClickEvents.forEach(mouseEventType =>
      element.dispatchEvent(
        new MouseEvent(mouseEventType, {
            view: window,
            bubbles: true,
            cancelable: true,
            buttons: 1
        })
      )
    );
  }

  const [view, setView] = useState(false);
    videoGalleryProps.onCreateLocalStreamView().then(() => {       
      if(!view) {
        setView(true);      
        setTimeout(() => {
          var camera = document.querySelector("button[id='CameraButton']");
          simulateMouseClick(camera);
          var microphone = document.querySelector("button[id='MicrophoneButton']");
          simulateMouseClick(microphone);        
        }, 5000);
      }    
  });

  const onHangup = useCallback(async (): Promise<void> => {
    await endCallProps.onHangUp();
    setCallEnded(true);
  }, [endCallProps]);

  if (callEnded) {
    props.onCallEnded();
  }
  const containerStyle = { 
    root: {
      height: "92vh",
    },
    };
  const controlBarStyle = {
    root: {
      justifyContent: "center",
      marginBottom: 10,
     
    },
  };
  return (
    <>
      <Stack styles={containerStyle}>
        <div
          style={{
            zIndex: 1,
            position: "absolute",
            top: 3,
            width : '97%',
            marginLeft : 30,
          }}
        >          
        </div>
        <div
          style={{
            height: "5000rem",
            border: "1px solid",
            position: "relative",
            marginLeft : 30,
            marginRight : 30,
            marginTop : 10
          }}
        >
          {/* <VideoGallery
            layout="floatingLocalVideo"
            localParticipant={MockLocalParticipant}
            remoteParticipants={MockRemoteParticipants}
          /> */}
          {videoGalleryProps && (
            <VideoGallery layout="floatingLocalVideo" {...videoGalleryProps} />
          )}
        </div>
        <ControlBar layout="floatingBottom" styles={controlBarStyle}>
          {/* <ControlBarButton
            key={"callProhibitedIcon"}
            onRenderIcon={() => (
              <CallProhibited20Filled
                key={"callProhibitedIconKey"}
                primaryFill="currentColor"
              />
            )}
            strings={{ label: "Dismiss" }}
            labelKey={"callProhibiteButtonLabel"}
            showLabel={true}
            onClick={() => {
              toggleHideDialog();
            }}
          /> */}
           {cameraProps && <CameraButton id="CameraButton" showLabel={true} {...cameraProps} />}          
           {microphoneProps && (            
              <MicrophoneButton id={"MicrophoneButton"} key={"MicrophoneButton"} showLabel={true} {...microphoneProps} />          
          )}
        </ControlBar>

        <Dialog
          hidden={hideDialog}
          onDismiss={toggleHideDialog}
          dialogContentProps={dialogContentProps}
          modalProps={modalProps}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <PrimaryButton
              onClick={() => {                
                history.push({
                  pathname: "/",
                  search: `?meetingId=${state.meetingId}`,
                  state: { meetingId: state.meetingId }
                });
              }}
              text="Return to home"
            />
          </div>
        </Dialog>
      </Stack>
    </>
  );
}

function CallEnded(): JSX.Element {
  return <h1>You ended the call.</h1>;
}

export default CallingComponents;
